
import { useMemo } from 'react';
import { ChartContainer } from "@/components/ui/chart";
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, Cell } from 'recharts';

interface PollResultsChartProps {
  votesDistribution: Array<{
    optionId: number;
    label: string;
    votes: number;
    percentage: number;
  }>;
  userVoteOptionId?: number | null;
}

const PollResultsChart = ({ votesDistribution, userVoteOptionId }: PollResultsChartProps) => {
  const chartConfig = useMemo(() => ({
    option: {
      label: 'Option',
      theme: {
        light: '#1E40AF', // blue-800
        dark: '#3B82F6', // blue-500
      },
    },
    userVote: {
      label: 'Your Vote',
      theme: {
        light: '#059669', // green-600
        dark: '#10B981', // green-500
      },
    },
  }), []);

  // Add debug logging to see what's being passed to the chart
  console.log('PollResultsChart votesDistribution:', votesDistribution);
  console.log('userVoteOptionId:', userVoteOptionId);

  if (!votesDistribution || votesDistribution.length === 0) {
    return (
      <div className="flex items-center justify-center h-40 bg-gray-50 dark:bg-gray-800 rounded-md border">
        <p className="text-gray-500 dark:text-gray-400">No voting data available</p>
      </div>
    );
  }

  return (
    <div className="w-full overflow-x-hidden">
      <div className="w-full min-w-0">
        <ChartContainer
          config={chartConfig}
          className="h-80 w-full min-w-0"
        >
          <ResponsiveContainer width="100%" height="100%" minWidth={0}>
            <BarChart
              data={votesDistribution}
              margin={{
                top: 5,
                right: 5,
                left: 5,
                bottom: 60,
              }}
              maxBarSize={60}
            >
              <XAxis
                dataKey="label"
                angle={-45}
                textAnchor="end"
                tick={{ fontSize: 11 }}
                height={60}
                interval={0}
                width={0}
              />
              <YAxis width={40} tick={{ fontSize: 11 }} />
              <Tooltip 
                formatter={(value: number) => [`${value} votes`, 'Votes']}
                labelFormatter={(label) => `Option: ${label}`}
              />
              <Bar dataKey="votes" name="Votes">
                {votesDistribution.map((entry, index) => (
                  <Cell
                    key={`cell-${index}`}
                    fill={entry.optionId === userVoteOptionId ? 'var(--color-userVote)' : 'var(--color-option)'}
                  />
                ))}
              </Bar>
            </BarChart>
          </ResponsiveContainer>
        </ChartContainer>
      </div>
    </div>
  );
};

export default PollResultsChart;
